import React from 'react';

import Search from './Search';
import DocumentList from './DocumentList';

function DocSearchPage() {
  return (
    <div
      style={{
        backgroundColor: 'white',
        minHeight: 'calc(100vh - 50px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Search />
      <DocumentList />
    </div>
  );
}

export default DocSearchPage;
